import {useEffect} from 'react'

const useGlobalSlickAccessibilityFix = () => {
    useEffect(() => {
        if (typeof window === 'undefined') return

        let debounceTimer = null
        const observedArrows = new Set()

        const updateSlideAccessibility = () => {
            document.querySelectorAll('.slick-slider').forEach((slider) => {
                const slides = slider.querySelectorAll('.slick-slide')
                slides.forEach((slide) => {
                    const hidden = slide.getAttribute('aria-hidden') === 'true'
                    const focusableElements = slide.querySelectorAll(
                        'a, button, input, textarea, select, [tabindex]'
                    )
                    focusableElements.forEach((el) => {
                        if (hidden) {
                            el.setAttribute('tabindex', '-1')
                            el.setAttribute('aria-hidden', 'true')
                        } else {
                            el.removeAttribute('tabindex')
                            el.removeAttribute('aria-hidden')
                        }
                    })
                })

                // Attach fix on arrow click (only once)
                slider.querySelectorAll('.slick-arrow').forEach((arrow) => {
                    if (!observedArrows.has(arrow)) {
                        arrow.addEventListener('click', scheduleFix)
                        observedArrows.add(arrow)
                    }
                })
            })
        }

        const slickList = document.querySelector(
            '.apparel-product-tile-carousel .slick-slider .slick-list'
        )
        if (slickList) {
            slickList.style.paddingRight = '160px'
        }

        const scheduleFix = () => {
            clearTimeout(debounceTimer)
            debounceTimer = setTimeout(updateSlideAccessibility, 100)
        }

        // Initial fix
        scheduleFix()

        // Observe slide changes
        const trackObserver = new MutationObserver(scheduleFix)
        const observeAllTracks = () => {
            document.querySelectorAll('.slick-track').forEach((track) => {
                trackObserver.observe(track, {childList: true, subtree: true})
            })
        }

        observeAllTracks()

        // Observe DOM in case new slick-tracks are added
        const domObserver = new MutationObserver(() => {
            observeAllTracks()
            scheduleFix()
        })

        domObserver.observe(document.body, {childList: true, subtree: true})

        // Support keyboard navigation
        const keyboardFixKeys = new Set(['Enter'])
        const handleKeydown = (e) => {
            if (keyboardFixKeys.has(e.key)) {
                scheduleFix()
            }
        }

        document.addEventListener('keydown', handleKeydown)

        // Cleanup
        return () => {
            clearTimeout(debounceTimer)
            trackObserver.disconnect()
            domObserver.disconnect()
            document.removeEventListener('keydown', handleKeydown)
            observedArrows.forEach((arrow) => arrow.removeEventListener('click', scheduleFix))
            observedArrows.clear()
        }
    }, [])
}

export default useGlobalSlickAccessibilityFix
